import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'src/app/shared/shared.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ERToolRoutingModule } from './er-tool-routing.module';
import { ERToolComponent } from './components/er-tool.component';
import { ErListComponent } from './components/er-list/er-list.component';
import { ImportWizardFileDownloadComponent } from './components/import-wizard-file-download/import-wizard-file-download.component';
import { SearchDrugListComponent } from './components/search-drug-list/search-drug-list.component';
import { ImportWizardSearchDrugComponent } from './components/import-wizard-search-drug/import-wizard-search-drug.component';
import { DrugDetailsComponent } from './components/drug-details/drug-details.component';
import { ImportWizardImageSlideComponent } from './components/import-wizard-image-slide/import-wizard-image-slide.component';
import { OtherBottleSizeWizardComponent } from './components/other-bottle-size-wizard/other-bottle-size-wizard.component';




@NgModule({
  declarations: [    
   ERToolComponent,
   ErListComponent,
   ImportWizardFileDownloadComponent,
   SearchDrugListComponent,
   ImportWizardSearchDrugComponent,
   DrugDetailsComponent,
   ImportWizardImageSlideComponent,
   OtherBottleSizeWizardComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    ScrollingModule,
    CdkTableModule,
    MatSortModule,
    MatTableModule,
    MatProgressSpinnerModule,
    ERToolRoutingModule
  ],
})
export class ERToolModule {}
